import * as React from "react";
import Typography from "@mui/material/Typography";
import VinSearch from "../components/search/VinSearch";
import InnerPage from "../components/InnerPage";

export default function VinSearchScreen() {
  return (
    <InnerPage title="Search by VIN">
      <VinSearch />
    </InnerPage>
  );
} 